import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { swal, typeChecker } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';

const RequestCategoriesCreate = ({ componentType='create' }) => {
	const { t } = useTranslation();
	const { id } = useParams();
    const navigate = useNavigate();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('request_categories'), link: '/request-categories-list' },
		{ title: t(componentType) }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const [createButtonIsLoading, setCreateButtonIsLoading] = useState(false);
	const createRequestcategory = async (event) => {
		event.preventDefault();
		if(createButtonIsLoading)
			return 0;
		let title = event.target.requestCategoryTitle.value.trim();
		if(!typeChecker(title, 'title'))
			return toast.warn(t('title') + ' ' + t('must_have_at_least_3_characters'));
		let is_active = event.target.requestCategoryIsActive.checked ? 1 : 0;
		let icon = document.querySelector('#requestCategoryIcon-upload-list img')?.getAttribute('src').trim() || '';
		if(!typeChecker(icon, 'image'))
			return toast.warn(t('icon') + ' ' + t('cant_be_empty'));
		let darkIcon = document.querySelector('#requestCategoryDarkIcon-upload-list img')?.getAttribute('src').trim() || '';
		if(!typeChecker(darkIcon, 'image'))
			return toast.warn(t('dark_mode_icon') + ' ' + t('cant_be_empty'));
		let description = event.target.requestCategoryDescription.value.trim();
		if(!typeChecker(description, 'title'))
			return toast.warn(t('description') + ' ' + t('must_have_at_least_3_characters'));
		let type = event.target.requestCategoryType.value;
		let body = {
			requestcategory_id: id,
			requestcategory_name: title,
			is_active,
			requestcategory_information: {
				description,
				icon,
				dark_icon: darkIcon,
				type
			}
		};
		confirmSwal(async () => {
			setCreateButtonIsLoading(true);
			let response = await _post('/requestcategories/admin/' + componentType, body);
			setCreateButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					if(componentType === 'create')
						event.target.reset();
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	const [deleteButtonIsLoading, setDeleteButtonIsLoading] = useState(false);
	const deleteRequestcategory = async () => {
		if(deleteButtonIsLoading)
			return 0;
		let body = {
			requestcategory_id: id
		};
		confirmSwal(async () => {
			setDeleteButtonIsLoading(true);
			let response = await _post('/requestcategories/admin/delete', body);
			setDeleteButtonIsLoading(false);
			switch(response.code){
				case 200:
					navigate("/request-categories-list");
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	const [requestcategory, setRequestcategory] = useState({});
	const getRequestcategory = async () => {
		let body = {
			requestcategory_id: id
		};
		let response = await _post('/requestcategories/admin/getOne', body);
		switch(response.code){
			case 200:
				setRequestcategory(response.data.requestcategory);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	const requestCategoryTypesList = [
		{ key: t('marketers_club'), value: 1 },
		{ key: t('portal'), value: 2 }
	];

	useEffect(() => {
		if(componentType === 'edit')
			getRequestcategory();
	}, []);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t(componentType)} {t('request_category')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={createRequestcategory}>
						<div className="row gx-2">
							<FormField fieldKey="requestCategoryTitle" title={t('title')} value={requestcategory?.requestcategory_name} required rtl />
							<FormField type="toggle" fieldKey="requestCategoryIsActive" title={t('active')} value={requestcategory?.is_active} required />
							<FormField type="image" fieldKey="requestCategoryIcon" title={t('icon')} value={requestcategory?.requestcategory_information?.icon} required tip="200*200" fileMaxSize={1} />
							<FormField type="image" fieldKey="requestCategoryDarkIcon" title={t('dark_mode_icon')} value={requestcategory?.requestcategory_information?.dark_icon} required tip="200*200" fileMaxSize={1} />
							<FormField type="text" fieldKey="requestCategoryDescription" title={t('description')} value={requestcategory?.requestcategory_information?.description} required rtl />
							<FormField type="select" fieldKey="requestCategoryType" title={t('type')} value={parseInt(requestcategory?.requestcategory_information?.type)} required selectItems={requestCategoryTypesList} />
						</div>
						<div>
							{componentType === 'create' ?
								<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={createButtonIsLoading}>
									<i className="fa fa-save"></i> {t('create')}
								</LoadingButton>
							:
								<>
									<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="edit" isLoading={createButtonIsLoading}>
										<i className="fa fa-save"></i> {t('update')}
									</LoadingButton>
									<LoadingButton className="btn btn-danger d-inline-block mt-3" onClick={deleteRequestcategory} type="button" name="delete" isLoading={deleteButtonIsLoading}>
										<i className="fa fa-trash"></i> {t('delete')}
									</LoadingButton>
								</>
							}
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default RequestCategoriesCreate;
